import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    const loc = useLocation();

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center text-[color:var(--gsf-green-700)]" data-testid="auth-loading">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to={`/admin/login?next=${encodeURIComponent(loc.pathname)}`} replace />;

    // Force password change flow
    if (user.must_change_password && loc.pathname !== "/admin/change-password") {
        return <Navigate to="/admin/change-password" replace />;
    }

    if (roles && roles.length > 0 && !roles.includes(user.role) && user.role !== "super_admin") {
        return (
            <div className="min-h-[50vh] flex items-center justify-center">
                <div className="text-center">
                    <h2 className="font-serif text-2xl text-[color:var(--gsf-green-700)]">Insufficient permissions</h2>
                    <p className="text-sm text-gray-500 mt-2">Your role does not have access to this area.</p>
                </div>
            </div>
        );
    }

    return children;
}
